import MenuStepBase from '../Bases/MenuStepBase'
import TimeFormatter from '../../../../src/assets/js/TimeFormatter'
export default{
    name: 'menubasicinfobase',
    extends : MenuStepBase,
    inject: ['eventBus'],
    props: {
        menu : {type : Object}
    },
    data () {
        return {
            fromTime : {
                HH: "10",
                mm: "00",
                ss: "00"
            },
            toTime : {
                HH: "12",
                mm: "00",
                ss: "00"
            },
            openingDays: [0, 1, 2, 3, 4, 5, 6],
            weekdays : [
                {text: 'Mon', value: 1},
                {text: 'Tue', value: 2},
                {text: 'Wed', value: 3},
                {text: 'Thu', value: 4},
                {text: 'Fri', value: 5},
                {text: 'Sat', value: 6},
                {text: 'Sun', value: 0}
            ]
        }
    },
    methods: {
        processToCheckWeekDays() {
            if(this.openingDays.includes(1)) {
                this.menu.monday = true;
            } else {
                this.menu.monday = false;
            }
            if(this.openingDays.includes(2)) {
                this.menu.tuesday = true;  
            } else {
                this.menu.tuesday = false;
            }
            if(this.openingDays.includes(3)) {
                this.menu.wednesday = true;
            } else {
                this.menu.wednesday = false;
            }
            if(this.openingDays.includes(4)) {
                this.menu.thursday = true;
            } else {
                this.menu.thursday = false;
            }
            if(this.openingDays.includes(5)) {
                this.menu.friday = true;
            } else {
                this.menu.friday = false;
            }
            if(this.openingDays.includes(6)) {
                this.menu.saturday = true;
            } else {
                this.menu.saturday = false;
            }
            if(this.openingDays.includes(0)) {
                this.menu.sunday = true;
            } else {
                this.menu.sunday = false;
            }
        },
        handleOnNextEvent() {
            this.processToCheckWeekDays(); 
            this.menu.fromTime = TimeFormatter.timeToString(this.fromTime);
            this.menu.toTime = TimeFormatter.timeToString(this.toTime);
        },
        handleOnBackEvent() {

        }
    },
    created() {
        
    }
}